import Transform from '@ember-data/serializer/transform';
export default class EpochDateTime extends Transform {
  serialize(date) {
    return date && date.getTime();
  }
  deserialize(proto) {
    if (proto !== null && proto !== undefined) {
      return new Date(proto);
    } else {
      return null;
    }
  }
}